package api.service.properties

import api.data.DataProperty
import api.data.request.DataAddProperty
import api.data.request.DataUpdateProperty
import api.data.request.DataUpdatedPropertyStatus
import api.data.request.toHashMap
import api.data.toDataProperty
import dev.gitlive.firebase.firestore.Direction
import dev.gitlive.firebase.firestore.FieldValue
import dev.gitlive.firebase.firestore.FirebaseFirestoreException
import firebaseFirestore
import kotlinx.css.th

fun DataAddProperty.toHashMap(): HashMap<String, Any?> {
    return hashMapOf(
        "id" to id,
        "title" to title,
        "location" to location,
        "size" to size,
        "bedrooms" to bedrooms,
        "bathrooms" to bathrooms,
        "description" to description,
        "type" to type,
        "price" to price,
        "currency" to currency,
        "amenities" to amenities,
        "yearBuilt" to yearBuilt,
        "images" to images,
        "ownerEmail" to ownerEmail,
        "ownerPhone" to ownerPhone,
        "ownerFirstName" to ownerFirstName,
        "ownerLastName" to ownerLastName,
        "purpose" to purpose,
        "status" to "Active",
        "isApproved" to isApproved,
        "rejectedBy" to rejectedBy,
        "rejectionReason" to rejectionReason,
        "approvedBy" to approvedBy,
        "approvedOn" to FieldValue.serverTimestamp,
        "createdOn" to FieldValue.serverTimestamp,
        "updatedOn" to FieldValue.serverTimestamp,
        "submittedBy" to submittedBy,
        "rentBillFrequency" to rentBillFrequency
    )
}

object ImplServiceProperties: ServiceProperties{
    override suspend fun addProperty(dataAddProperty: DataAddProperty): Boolean {
        try {
                firebaseFirestore.collection("Properties").document(dataAddProperty.id.toString())
                    .set(dataAddProperty.toHashMap())
            return true
        } catch (e: FirebaseFirestoreException){
            throw e
        }
    }

    override suspend fun getProperties(): ArrayList<DataProperty>? {
        val dataProperty = ArrayList<DataProperty>()
        try{
            firebaseFirestore.collection("Properties").orderBy("createdOn", Direction.DESCENDING).get().documents
                .forEach { document ->
                     if (document.exists){
                        dataProperty.add(document.toDataProperty())

                    } else{
                       return null
                    }
                }
            return dataProperty
        }
        catch (e: FirebaseFirestoreException){
            throw e
        }
    }

    override suspend fun updateProperty(dataUpdateProperty: DataUpdateProperty): Boolean {
        try {
            firebaseFirestore.collection("Properties").document(dataUpdateProperty.id.toString())
                .update(dataUpdateProperty.toHashMap())
            return true
        } catch (e: FirebaseFirestoreException){
            throw e
        }
    }

    override suspend fun removeProperty(dataProperty: DataProperty): Boolean {
       try {
           firebaseFirestore.collection("Properties").document(dataProperty.id.toString())
               .delete()
           return true
       } catch (e: FirebaseFirestoreException){
           throw e
       }
    }

    override suspend fun approveProperty(dataProperty: DataProperty): Boolean {
        try {
            firebaseFirestore.collection("Properties").document(dataProperty.id.toString())
                .update(dataProperty)
            return true
        } catch (e: FirebaseFirestoreException){
            throw e
        }
    }

    override suspend fun rejectProperty(dataProperty: DataProperty): Boolean {
        try {
            firebaseFirestore.collection("Properties").document(dataProperty.id.toString())
                .update(dataProperty)
            return true
        } catch (e: FirebaseFirestoreException){
            throw e
        }
    }

    override suspend fun updatePropertyStatus(dataUpdateStatus: DataUpdatedPropertyStatus): Boolean {
        try {
            firebaseFirestore.collection("Properties").document(dataUpdateStatus.id)
                .update(dataUpdateStatus.toHashMap())
            return true
        }
        catch (e: FirebaseFirestoreException){
            throw e
        }
    }

}